export default {
  [['html', 'body', '#root'].join(',')]: {
    height: '100%',
  },
};
